import 'angular:locale/data:pl';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "pl";
